// Task Status System - Constants, Colors, Transitions

export const TASK_STATUSES = [
  { value: 'assigned', label: 'Assigned', color: 'bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-700 dark:text-slate-200 dark:border-slate-600', dotColor: 'bg-slate-400', order: 0 },
  { value: 'todo', label: 'To Do', color: 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-700', dotColor: 'bg-blue-400', order: 1 },
  { value: 'in_progress', label: 'In Progress', color: 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-700', dotColor: 'bg-amber-400', order: 2 },
  { value: 'pending', label: 'Pending', color: 'bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-900/30 dark:text-orange-300 dark:border-orange-700', dotColor: 'bg-orange-400', order: 3 },
  { value: 'awaiting_review', label: 'Awaiting Review', color: 'bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-900/30 dark:text-purple-300 dark:border-purple-700', dotColor: 'bg-purple-400', order: 4 },
  { value: 'approved', label: 'Approved', color: 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-700', dotColor: 'bg-emerald-400', order: 5 },
  { value: 'completed', label: 'Completed', color: 'bg-gray-100 text-gray-500 border-gray-200 dark:bg-gray-700 dark:text-gray-400 dark:border-gray-600', dotColor: 'bg-gray-400', order: 6 },
];

export const OPEN_STATUSES = ['assigned', 'todo', 'in_progress', 'pending', 'awaiting_review', 'approved'];

export const getStatusConfig = (status) => {
  return TASK_STATUSES.find(s => s.value === status) || TASK_STATUSES[0];
};

export const getStatusLabel = (status) => getStatusConfig(status).label;

// User can move forward in the chain, but not past awaiting_review if requires_approval
export const getUserAllowedStatuses = (currentStatus, requiresApproval) => {
  const currentOrder = getStatusConfig(currentStatus).order;
  return TASK_STATUSES.filter(s => {
    if (s.value === currentStatus) return true; // always include current
    if (requiresApproval) {
      // Can't go to approved or completed
      return s.order <= 4 && s.order >= currentOrder;
    }
    // Can skip approved and go to completed
    return s.value !== 'approved' && s.order >= currentOrder;
  });
};

// Manager can move to any status
export const getManagerAllowedStatuses = () => TASK_STATUSES;

// Date filter helpers
export const DATE_FILTERS = [
  { value: 'all', label: 'All Dates' },
  { value: 'overdue', label: 'Overdue', color: 'text-red-500' },
  { value: 'today', label: 'Today', color: 'text-orange-500' },
  { value: 'upcoming', label: 'Upcoming', color: 'text-blue-500' },
  { value: 'no_date', label: 'No Due Date', color: 'text-gray-400' },
];

// Get date category for a task
export const getDateCategory = (dueDate, isCompleted) => {
  if (!dueDate) return 'no_date';
  if (isCompleted) return 'completed';
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const due = new Date(dueDate);
  due.setHours(0, 0, 0, 0);
  if (due < today) return 'overdue';
  if (due.getTime() === today.getTime()) return 'today';
  return 'upcoming';
};

// Color for date category
export const getDateCategoryColor = (category) => {
  switch (category) {
    case 'overdue': return 'text-red-500';
    case 'today': return 'text-orange-500';
    case 'upcoming': return 'text-blue-500';
    case 'no_date': return 'text-gray-400';
    default: return 'text-gray-500';
  }
};

// Kanban grouping options
export const KANBAN_GROUP_OPTIONS = [
  { value: 'status', label: 'Status' },
  { value: 'assignee', label: 'Assigned Member' },
  { value: 'date', label: 'Date (Overdue / Today / Upcoming)' },
];
